export default __webpack_public_path__ + "static/media/T_Tartaruga.8f73b8fc.mp3";